export const countryCodes = [
    { code: "91", name: "IN" }, // India
    { code: "93", name: "AF" }, // Afghanistan
    { code: "355", name: "AL" }, // Albania
    { code: "213", name: "DZ" }, // Algeria
    { code: "376", name: "AD" }, // Andorra
    { code: "244", name: "AO" }, // Angola
    { code: "1-268", name: "AG" }, // Antigua and Barbuda
    { code: "54", name: "AR" }, // Argentina
    { code: "374", name: "AM" }, // Armenia
    { code: "61", name: "AU" }, // Australia
    { code: "43", name: "AT" }, // Austria
    { code: "994", name: "AZ" }, // Azerbaijan
    { code: "1-242", name: "BS" }, // Bahamas
    { code: "973", name: "BH" }, // Bahrain
    { code: "880", name: "BD" }, // Bangladesh
    { code: "1-246", name: "BB" }, // Barbados
    { code: "375", name: "BY" }, // Belarus
    { code: "32", name: "BE" }, // Belgium
    { code: "501", name: "BZ" }, // Belize
    { code: "229", name: "BJ" }, // Benin
    { code: "975", name: "BT" }, // Bhutan
    { code: "591", name: "BO" }, // Bolivia
    { code: "387", name: "BA" }, // Bosnia and Herzegovina
    { code: "267", name: "BW" }, // Botswana
    { code: "55", name: "BR" }, // Brazil
    { code: "673", name: "BN" }, // Brunei
    { code: "359", name: "BG" }, // Bulgaria
    { code: "226", name: "BF" }, // Burkina Faso
    { code: "257", name: "BI" }, // Burundi
    { code: "855", name: "KH" }, // Cambodia
    { code: "237", name: "CM" }, // Cameroon
    { code: "1", name: "CA" }, // Canada
    { code: "238", name: "CV" }, // Cape Verde
    { code: "236", name: "CF" }, // Central African Republic
    { code: "235", name: "TD" }, // Chad
    { code: "56", name: "CL" }, // Chile
    { code: "86", name: "CN" }, // China
    { code: "57", name: "CO" }, // Colombia
    { code: "269", name: "KM" }, // Comoros
    { code: "243", name: "CD" }, // Congo, Democratic Republic of the
    { code: "242", name: "CG" }, // Congo, Republic of the
    { code: "506", name: "CR" }, // Costa Rica
    { code: "385", name: "HR" }, // Croatia
    { code: "53", name: "CU" }, // Cuba
    { code: "357", name: "CY" }, // Cyprus
    { code: "420", name: "CZ" }, // Czech Republic
    { code: "45", name: "DK" }, // Denmark
    { code: "253", name: "DJ" }, // Djibouti
    { code: "1-767", name: "DM" }, // Dominica
    { code: "1-809", name: "DO" }, // Dominican Republic
    { code: "670", name: "TL" }, // East Timor
    { code: "593", name: "EC" }, // Ecuador
    { code: "20", name: "EG" }, // Egypt
    { code: "503", name: "SV" }, // El Salvador
    { code: "240", name: "GQ" }, // Equatorial Guinea
    { code: "291", name: "ER" }, // Eritrea
    { code: "372", name: "EE" }, // Estonia
    { code: "251", name: "ET" }, // Ethiopia
    { code: "679", name: "FJ" }, // Fiji
    { code: "358", name: "FI" }, // Finland
    { code: "33", name: "FR" }, // France
    { code: "241", name: "GA" }, // Gabon
    { code: "220", name: "GM" }, // Gambia
    { code: "995", name: "GE" }, // Georgia
    { code: "49", name: "DE" }, // Germany
    { code: "233", name: "GH" }, // Ghana
    { code: "30", name: "GR" }, // Greece
    { code: "1-473", name: "GD" }, // Grenada
    { code: "502", name: "GT" }, // Guatemala
    { code: "224", name: "GN" }, // Guinea
    { code: "245", name: "GW" }, // Guinea-Bissau
    { code: "592", name: "GY" }, // Guyana
    { code: "509", name: "HT" }, // Haiti
    { code: "504", name: "HN" }, // Honduras
    { code: "852", name: "HK" }, // Hong Kong
    { code: "36", name: "HU" }, // Hungary
    { code: "354", name: "IS" }, // Iceland
    { code: "62", name: "ID" }, // Indonesia
    { code: "98", name: "IR" }, // Iran
    { code: "964", name: "IQ" }, // Iraq
    { code: "353", name: "IE" }, // Ireland
    { code: "972", name: "IL" }, // Israel
    { code: "39", name: "IT" }, // Italy
    { code: "1-876", name: "JM" }, // Jamaica
    { code: "81", name: "JP" }, // Japan
    { code: "962", name: "JO" }, // Jordan
    { code: "7", name: "KZ" }, // Kazakhstan
    { code: "254", name: "KE" }, // Kenya
    { code: "686", name: "KI" }, // Kiribati
    { code: "850", name: "KP" }, // Korea, North
    { code: "82", name: "KR" }, // Korea, South
    { code: "965", name: "KW" }, // Kuwait
    { code: "996", name: "KG" }, // Kyrgyzstan
    { code: "856", name: "LA" }, // Laos
    { code: "371", name: "LV" }, // Latvia
    { code: "961", name: "LB" }, // Lebanon
    { code: "266", name: "LS" }, // Lesotho
    { code: "231", name: "LR" }, // Liberia
    { code: "218", name: "LY" }, // Libya
    { code: "423", name: "LI" }, // Liechtenstein
    { code: "370", name: "LT" }, // Lithuania
    { code: "352", name: "LU" }, // Luxembourg
    { code: "853", name: "MO" }, // Macau
    { code: "389", name: "MK" }, // Macedonia
    { code: "261", name: "MG" }, // Madagascar
    { code: "265", name: "MW" }, // Malawi
    { code: "60", name: "MY" }, // Malaysia
    { code: "960", name: "MV" }, // Maldives
    { code: "223", name: "ML" }, // Mali
    { code: "356", name: "MT" }, // Malta
    { code: "692", name: "MH" }, // Marshall Islands
    { code: "222", name: "MR" }, // Mauritania
    { code: "230", name: "MU" }, // Mauritius
    { code: "52", name: "MX" }, // Mexico
    { code: "691", name: "FM" }, // Micronesia
    { code: "373", name: "MD" }, // Moldova
    { code: "377", name: "MC" }, // Monaco
    { code: "976", name: "MN" }, // Mongolia
    { code: "382", name: "ME" }, // Montenegro
    { code: "212", name: "MA" }, // Morocco
    { code: "258", name: "MZ" }, // Mozambique
    { code: "95", name: "MM" }, // Myanmar
    { code: "264", name: "NA" }, // Namibia
    { code: "674", name: "NR" }, // Nauru
    { code: "977", name: "NP" }, // Nepal
    { code: "31", name: "NL" }, // Netherlands
    { code: "64", name: "NZ" }, // New Zealand
    { code: "505", name: "NI" }, // Nicaragua
    { code: "227", name: "NE" }, // Niger
    { code: "234", name: "NG" }, // Nigeria
    { code: "47", name: "NO" }, // Norway
    { code: "968", name: "OM" }, // Oman
    { code: "92", name: "PK" }, // Pakistan
    { code: "680", name: "PW" }, // Palau
    { code: "970", name: "PS" }, // Palestine
    { code: "507", name: "PA" }, // Panama
    { code: "675", name: "PG" }, // Papua New Guinea
    { code: "595", name: "PY" }, // Paraguay
    { code: "51", name: "PE" }, // Peru
    { code: "63", name: "PH" }, // Philippines
    { code: "48", name: "PL" }, // Poland
    { code: "351", name: "PT" }, // Portugal
    { code: "974", name: "QA" }, // Qatar
    { code: "40", name: "RO" }, // Romania
    { code: "7", name: "RU" }, // Russia
    { code: "250", name: "RW" }, // Rwanda
    { code: "1-869", name: "KN" }, // Saint Kitts and Nevis
    { code: "1-758", name: "LC" }, // Saint Lucia
    { code: "1-784", name: "VC" }, // Saint Vincent and the Grenadines
    { code: "685", name: "WS" }, // Samoa
    { code: "378", name: "SM" }, // San Marino
    { code: "239", name: "ST" }, // Sao Tome and Principe
    { code: "966", name: "SA" }, // Saudi Arabia
    { code: "221", name: "SN" }, // Senegal
    { code: "381", name: "RS" }, // Serbia
    { code: "248", name: "SC" }, // Seychelles
    { code: "232", name: "SL" }, // Sierra Leone
    { code: "65", name: "SG" }, // Singapore
    { code: "421", name: "SK" }, // Slovakia
    { code: "386", name: "SI" }, // Slovenia
    { code: "677", name: "SB" }, // Solomon Islands
    { code: "252", name: "SO" }, // Somalia
    { code: "27", name: "ZA" }, // South Africa
    { code: "211", name: "SS" }, // South Sudan
    { code: "34", name: "ES" }, // Spain
    { code: "94", name: "LK" }, // Sri Lanka
    { code: "249", name: "SD" }, // Sudan
    { code: "597", name: "SR" }, // Suriname
    { code: "46", name: "SE" }, // Sweden
    { code: "41", name: "CH" }, // Switzerland
    { code: "963", name: "SY" }, // Syria
    { code: "886", name: "TW" }, // Taiwan
    { code: "992", name: "TJ" }, // Tajikistan
    { code: "255", name: "TZ" }, // Tanzania
    { code: "66", name: "TH" }, // Thailand
    { code: "228", name: "TG" }, // Togo
    { code: "676", name: "TO" }, // Tonga
    { code: "1-868", name: "TT" }, // Trinidad and Tobago
    { code: "216", name: "TN" }, // Tunisia
    { code: "90", name: "TR" }, // Turkey
    { code: "993", name: "TM" }, // Turkmenistan
    { code: "688", name: "TV" }, // Tuvalu
    { code: "256", name: "UG" }, // Uganda
    { code: "380", name: "UA" }, // Ukraine
    { code: "971", name: "AE" }, // United Arab Emirates
    { code: "44", name: "GB" }, // United Kingdom
    { code: "1", name: "US" }, // United States
    { code: "598", name: "UY" }, // Uruguay
    { code: "998", name: "UZ" }, // Uzbekistan
    { code: "678", name: "VU" }, // Vanuatu
    { code: "58", name: "VE" }, // Venezuela
    { code: "84", name: "VN" }, // Vietnam
    { code: "967", name: "YE" }, // Yemen
    { code: "260", name: "ZM" }, // Zambia
    { code: "263", name: "ZW" } // Zimbabwe
  ];